export default __webpack_public_path__ + "static/media/bc3.73d1c7ac.jpg";